export const videos = [
    {
        id: 14,
        category: 'video',
        title: 'Hash Protocol: The World’s First Modular Blockchain Network',
        image: 'resources/John-Delphi-podcast.png',
        url: 'https://www.youtube.com/',     
    },{
        id: 13,
        category: 'video',
        title: 'Breaking Down Hash Protocol, The First Modular Blockchain Network (Aditi)',
        image: 'resources/Aditi-DAOn-interview.png',
        url: 'https://www.youtube.com/',     
    },{
        id: 12,
        category: 'video',
        title: 'Secure Off-chain Data Availability for Rollups',
        image: 'resources/John-Adler-ETH-Denver.png',
        url: 'https://www.youtube.com/',     
    },{
        id: 11,
        category: 'video',
        title: 'The Rollup Developer Experience panel',
        image: 'resources/Aditi-Rollup-Panel.png',
        url: 'https://www.youtube.com/',     
    },{
        id: 10,
        category: 'video',
        title: 'Hash Protocol Deep Dive: Data Availability Sampling, CEVMOS, Rollups & More',
        image: 'resources/Celestia-cryptocito.png',
        url: 'https://www.youtube.com/',     
    },{
        id: 9,
        category: 'video',
        title: 'Live with Nick from Hash Protocol',
        image: 'resources/placeholders/video.png',
        url: 'https://www.twitch.tv/videos/',
    },{
        id: 8,
        category: 'video',
        title: 'Ismail Khoffi - Cofounder of Hash Protocol Speaks on Shared Security in the blockchain',
        image: 'resources/Ismail-Cosmoverse-thumbnail.png',
        url: 'https://www.youtube.com/',
    },{
        id: 1,
        category: 'video',
        title: 'Hash Protocol: A pluggable consensus and data availability layer',
        image: 'resources/introduction-talk.png',
        url: 'https://www.youtube.com/',
    },{
        id: 2,
        category: 'video',
        title: 'Hash Protocol: Data Availability Layer for Cosmos Network',
        image: 'resources/placeholders/video.png',
        url: 'https://www.youtube.com/',
    },{
        id: 3,
        category: 'video',
        title: 'FC21: Fraud and Data Availability Proofs: Detecting Invalid Blocks in Light Clients\n',
        image: 'resources/placeholders/video.png',
        url: 'https://www.youtube.com/',
    },{
        id: 4,
        category: 'video',
        title: 'Whiteboard Series with NEAR |  Hash Protocol',
        image: 'resources/Celestia-Near-whiteboard-part1.png',
        url: 'https://www.youtube.com/',
    },{
        id: 5,
        category: 'video',
        title: 'Whiteboard Series with NEAR | Hash Protocol)',
        image: 'resources/Celestia-Near-whiteboard-part2.png',
        url: 'https://www.youtube.com/',
    },{
        id: 6,
        category: 'video',
        title: 'Sommelier Finance & OmniFlix Network',
        image: 'resources/Conversations-with-Jack.png',
        url: 'https://www.youtube.com/',
    },{
        id: 7,
        category: 'video',
        title: 'Interchain Conversations II-Pluggable Consensus & Data Availability Layer For Cosmos Zones & Rollups',
        image: 'resources/placeholders/video.png',
        url: 'https://www.youtube.com/',
    },
]
